import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";

export const showDeadlineShippingOrderTabs = [
    OrderTab.PENDING_SHIPMENT,
    OrderTab.ON_HOLD,
    OrderTab.PENDING_SHIPMENT_REFUNDING,
];
